module.exports = __webpack_public_path__ + "b8f6fdce534049ff41abb2ad7a308e68.jpg";